module.exports = __webpack_public_path__ + "media/images/siq_shield_white_hollow-ba9b1524a3a0c677454f0fb9b75f11a7.svg";